<template>
  <div class="container pb-6 pb-8 pt-5 pt-md-8">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card-header mt-4 text-center">
          <!-- Profile Picture -->
          <div class="col-md-12 text-center mt-4" id="file-input">
            <label>
              <input type="file" @change="setImage" :disabled="isAdmin" />
              <img class="avatar avatar-lg rounded-circle" id="profile-picture" :src="cropImg" alt />
            </label>

            <modal :show.sync="showModal">
              <div class="mt-4 mb-4">
                <vue-cropper
                  ref="cropper"
                  :guides="true"
                  :view-mode="2"
                  drag-mode="crop"
                  :auto-crop-area="0.5"
                  :min-container-width="250"
                  :min-container-height="180"
                  :background="true"
                  :rotatable="true"
                  :src="imgSrc"
                  alt="Source Image"
                  :img-style="{ 'width': '400px', 'height': '300px' }"
                ></vue-cropper>
                <base-button
                  outline
                  type="primary"
                  class="mt-6"
                  @click="cropImage"
                >Crop Profile Picture</base-button>
              </div>
            </modal>
          </div>
          <!--  -->
          <!-- Region -->
          <div class="col-md-12 text-left mt-5">
            <label for="Region" class="form-control-title">Region</label>
            <input
              class="form-control input"
              disabled
              type="text"
              v-if="user"
              :value="user.region === 'khmer' ? 'Cambodia' : 'Thai'"
            />
          </div>
          <!--  -->
          <!-- First Name -->
          <div class="col-md-12 text-left mt-4">
            <label for="First Name" class="form-control-title">First Name</label>
            <input class="form-control input" type="text" v-model="firstName" :disabled="isAdmin" />
          </div>
          <!--  -->
          <!-- Last Name -->
          <div class="col-md-12 text-left mt-4">
            <label for="Last Name" class="form-control-title">Last Name</label>
            <input class="form-control input" type="text" v-model="lastName" :disabled="isAdmin" />
          </div>
          <!--  -->
          <!-- Email -->
          <div class="col-md-12 text-left mt-4">
            <label for="Email" class="form-control-title">Email</label>
            <input class="form-control input" type="text" v-model="email" :disabled="isAdmin" />
          </div>
          <!--  -->
          <!-- Phone -->
          <!-- <div class="col-md-12 text-left mt-4">
            <label for="Phone" class="form-control-title">Phone</label>
            <input class="form-control input" type="text" value="010973923" />
          </div>-->
          <!--  -->

          <div class="col-md-12 text-left mt-3" style="padding-left: 0 !important">
            <base-button type="link" @click="onChangePasswordClicked()">Change Password</base-button>
          </div>

          <div class="col-md-12 mt-5 mb-4">
            <base-button type="primary" @click="onUpdateClicked()" v-if="!isAdmin">Update</base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

import { mapState, mapGetters } from 'vuex'

import { GET_PROFILE, UPLOAD_FILE, UPDATE_PROFILE } from '@/store/actions.type'

const MAX_IMAGE_FILE_SIZE = 500 * 1000

export default {
  components: { VueCropper },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      // phone: '',
      imgSrc: require('@/assets/default_profile_picture.png'),
      cropImg: require('@/assets/default_profile_picture.png'),
      showModal: false
    }
  },
  mounted() {
    this.$store.dispatch(GET_PROFILE).then(() => {
      this.firstName = this.user.firstName
      this.lastName = this.user.lastName
      this.email = this.user.email

      if (this.user.profile) {
        this.cropImg = this.user.profile
      }
    })
  },
  beforeDestroy() {
    this.$store.state.file.fileUrl = null
  },
  methods: {
    onUpdateClicked() {
      if (this.firstName && this.lastName && this.email) {
        this.isLoading = true
        var url = this.profileUrl
        if (!url) {
          if (this.user.profile) {
            url = this.user.profile
          } else {
            url = ''
          }
        }
        this.$store
          .dispatch(UPDATE_PROFILE, {
            streamerId: this.user.streamerId,
            profile: url,
            firstName: this.firstName,
            lastName: this.lastName,
            streamerName: this.firstName + ' ' + this.lastName,
            email: this.email,
            country: this.user.region,
            canUpdateViewer: this.canAddFakeViewers
          })
          .then(() => {
            this.isLoading = false
          })
          .catch(() => {
            this.isLoading = false
          })
      } else {
        // this.isInputValid = false
      }
    },
    setImage(e) {
      this.$emit('input', e.target.files[0])
      const file = e.target.files[0]
      if (!file.type.includes('image/')) {
        alert('Please select an image file')
        return
      }
      if (file.size >= MAX_IMAGE_FILE_SIZE) {
        alert('Please select a smaller image size')
        return
      }
      if (typeof FileReader === 'function') {
        this.showModal = true
        const reader = new FileReader()
        reader.onload = event => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
        }
        reader.readAsDataURL(file)
      }
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
      const file = this.dataURLtoFile(this.cropImg, this.fileName)
      this.$store
        .dispatch(UPLOAD_FILE, { file, imageType: 'uploads' })
        .then(() => {
          this.showModal = false
        })
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onChangePasswordClicked() {
      this.$router.push({ path: '/change_password' })
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.userProfile,
      profileUrl: state => state.file.fileUrl
    }),
    ...mapGetters(['isAdmin', 'canAddFakeViewers'])
  }
}
</script>

<style scoped>
#file-input {
  display: inline-block !important;
}
#file-input input[type='file'] {
  display: none !important;
}
#profile-picture {
  cursor: pointer;
}
.avatar-lg {
  width: 100px !important;
  height: 100px !important;
}

input[type='text'],
select.form-control {
  background: transparent;
  border: none;
  border-bottom: 1px solid #e0e0e0;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
  padding: 0 !important;
  height: calc(1em + 1rem + 2px);
  font-size: 16px;
}

input[type='text']:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none !important;
  border-bottom: 1.5px solid #962100;
}
.form-control-title {
  margin-bottom: 0 !important;
  font-size: 12px !important;
  color: #666666 !important;
}
.btn:active,
.btn.active {
  background-image: none !important;
  outline: 0 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>
